<template>
  <div
    class="grid border-t py-2.5 gap-x-3 h-full"
    style="grid-template-columns: 0.7fr 1fr"
  >
    <div class="border p-5 rounded flex flex-col gap-y-3">
      <ul class="flex items-center gap-x-2">
        <strong class="text-lg">张倩惠</strong>
        <c_sex value="女" />
        <el-tag
          size="small"
          color="#776034"
          :hit="true"
          effect="light"
          style="color: #edca4f; border: 0; font-size: 11px"
        >
          嘉宾
        </el-tag>
        <li class="flex-1">ZHANGQIANHUI</li>
        <el-button type="primary" plain link>
          <template #icon>
            <el-icon :size="22" class="font-bold">
              <Edit />
            </el-icon>
          </template>
        </el-button>
      </ul>
      <c_cell title="证件号" value="34102932332" />
      <c_cell title="电话" value="180****0000" />
      <c_cell title="邮箱" value="2222222@qq.com" />
      <c_cell
        title="地址"
        class="!items-start"
        value="安徽省合肥市庐阳区长江东路1256号金华大厦1楼056商铺"
      />
      <c_cell title="单位" value="南方医科大学血液病研究院" />
      <c_cell title="职务" value="血液病研究院院长" />
      <c_cell title="简介" value="-" />
    </div>
    <div class="flex flex-col overflow-hidden bg-white">
      <div class="flex px-5">
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 0
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 0"
        >
          报名信息
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 1
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 1"
        >
          日程信息
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 2
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 2"
        >
          接送机
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 3
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 3"
        >
          住宿
        </li>
      </div>
      <div class="flex-1 rounded-lg bg-gray-100 flex overflow-hidden">
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 0"
        >
          <c_baoming />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 1"
        >
          <c_richeng />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 2"
        >
          <c_jiesongji />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 3"
        >
          <c_zhusu />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_baoming from "./Detail/BaoMing/Index.vue";
import c_richeng from "./Detail/RiCheng/Index.vue";
import c_jiesongji from "./Detail/JieSongJi/Index.vue";
import c_zhusu from "./Detail/ZhuSu/Index.vue";

export default {
  components: {
    c_baoming,
    c_richeng,
    c_jiesongji,
    c_zhusu,
  },
  setup() {
    const state = reactive({
      model: {},
      nav_index: 0,
    });
    onMounted(() => {});
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
